import { render } from "./MenuNavigation.vue?vue&type=template&id=f0b457d2&scoped=true"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"

import "./MenuNavigation.vue?vue&type=style&index=0&id=f0b457d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b457d2"]])

export default __exports__